import { render, staticRenderFns } from "./beneficiary-bill-payment.vue?vue&type=template&id=9c4604b0&"
import script from "./beneficiary-bill-payment.vue?vue&type=script&lang=js&"
export * from "./beneficiary-bill-payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports